<p-dialog [(visible)]="display" [resizable]="false" [modal]="true" [style]="{'width': '420px'}" (onHide)="hide()"
	appendTo="body">
	<p-header>
		<span>Export Map to PRTG (Data Only)</span>
	</p-header>

	<div class="mb-3">
		<p>
			Sends device, sensor, and tag information to the UVexplorer service running on
			the chosen PRTG server. (Hosted PRTG is not supported.)
		</p>
	</div>

	@if (loading) {
	<div class="mb-3">Loading PRTG agents…</div>
	}

	@if (errorMessage) {
	<div class="mb-3 text-danger">{{ errorMessage }}</div>
	}

	@if (!loading && !errorMessage && dropdownOptions.length > 0) {
	<div class="mb-3 row">
		<label class="col-lg-4 col-form-label">PRTG Server:</label>
		<div class="col-lg-8">
			<p-dropdown [options]="dropdownOptions" [(ngModel)]="selectedGuid" [style]="{'width': '100%'}"
				appendTo="body" placeholder="Select a PRTG server">
			</p-dropdown>
		</div>
	</div>
	}

	<p-footer>
		<button type="button" pButton icon="fa fa-check" (click)="export()" label="Export"
			[disabled]="!enableExport"></button>
		<button type="button" pButton icon="fa fa-close" (click)="cancel()" label="Cancel"></button>
	</p-footer>

</p-dialog>